export default __webpack_public_path__ + "static/media/filter-list.a2395785.svg";